import type {FC} from 'react';

import type {CallToActionProps} from '@/modules/foundation/components/call-to-action/CallToAction';
import {CallToAction} from '@/modules/foundation/components/call-to-action/CallToAction';
import type {CallToActionGroupProps} from '@/modules/foundation/components/call-to-action-group/CallToActionGroup';
import {CallToActionGroup} from '@/modules/foundation/components/call-to-action-group/CallToActionGroup';

import {linkFragmentToHref} from '../../link/query';

import type {CallToActionLineFragment} from './query';

export type CallToActionLineContainerProps = {
	value: CallToActionLineFragment;
	className?: string;
	callToActionGroupProps?: Partial<CallToActionGroupProps>;
	callToActionProps?: Partial<CallToActionProps>;
};

export const CallToActionLineContainer: FC<CallToActionLineContainerProps> = ({
	value,
	className,
	callToActionGroupProps,
	callToActionProps,
}) => {
	return (
		<CallToActionGroup className={className} {...callToActionGroupProps}>
			{value.callToActions?.map((cta) => (
				<CallToAction
					key={cta._key}
					text={cta.text ?? ''}
					variant={cta.variant}
					targetBlank={cta.targetBlank}
					href={linkFragmentToHref({
						type: cta.type,
						href: cta.href,
						reference: cta.reference,
						targetBlank: cta.targetBlank,
					})}
					{...callToActionProps}
				/>
			))}
		</CallToActionGroup>
	);
};
